export default __webpack_public_path__ + "static/media/snapshot-white.75772572.svg";